module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_j_piebald.a227c094.png";